export default {
  name: "FolderCard",
  props: {
    fileName: String,
    fileDate: String,
    url: String,
    iconSize: {
      type: String,
      default: "33px"
    },
    iconMargin: {
      type: String,
      default: "8px"
    },
    contentMarginRight: {
      type: String,
      default: "20px"
    },
    close: {
      type: Boolean,
      default: true
    }
  },
  setup(props, {
    emit
  }) {
    let enUrl = props.url;
    let fileType = props.fileName;
    if (props.fileName) {
      if (props.fileName.toLowerCase().endsWith(".pdf") == true) {
        enUrl = "/pdfjs/web/viewer.html?file=" + encodeURIComponent(props.url);
      }
      let type = props.fileName.split('.')[props.fileName.split('.').length - 1];
      if (type == 'excel') {
        fileType = 'fileIcon_excel';
      } else if (type == 'jpg') {
        fileType = 'fileIcon_jpg';
      } else if (type == 'pdf') {
        fileType = 'fileIcon_pdf';
      } else if (type == 'svg') {
        fileType = 'fileIcon_svg';
      } else if (type == 'ppt') {
        fileType = 'fileIcon_ppt';
      } else if (type == 'word') {
        fileType = 'fileIcon_word';
      } else {
        fileType = 'fileIcon_other';
      }
    }
    const removeDiv = () => {
      emit("remove");
    };
    return {
      removeDiv,
      enUrl,
      fileType
    };
  }
};